import React from 'react';
import { useTranslation } from 'react-i18next';
import errorImage from '@/assets/images/error.webp';
import { EmptyState } from '@/components/EmptyState';

export const PdfLoadError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex size-full">
      <EmptyState image={errorImage} label={t('global.errorOccurred')} />
    </div>
  );
};
